import React, { memo } from 'react'

// app inputs
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

// html editor
import HTMLEditor from 'utlis/helpers/HTMLEditor'

function FormBasicDetails(props) {
    const {
        formik,

        getDesc
    } = props

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner product-basic-info-column">
                    {/* inline form fields */}
                    <div className="d-flex flex-wrap inline-form-fields">
                        {/* form field */}
                        <AppFormikInput
                            // inputType={""}
                            formik={formik} // formik object
                            stFormClass={"product-name-field media-body"} // class name for main wrapper
                            labelName={"Product Name"} // label name
                            isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"Product Name"} // placeholder for the input
                            formikFieldName={"productName"} // important: formik value name for the input
                        />

                        {/* form field */}
                        <AppFormikInput
                            // inputType={""}
                            formik={formik} // formik object
                            stFormClass={"product-sku-field"} // class name for main wrapper
                            labelName={"SKU"} // label name
                            isRequired={true} // is this field is required or not to show the red star sign
                            placeholder={"SKU"} // placeholder for the input
                            formikFieldName={"SKU"} // important: formik value name for the input
                        />

                    </div>

                    {/* inline form fields */}
                    <div className="inline-form-fields">
                        {/* form field */}
                        <div className={`st-form product-description-field mb-0 ${(formik.touched.description && formik.errors.description) ? "has-msg msg-error" : ""}`}>
                            <label>
                                Description
                            </label>
                            <HTMLEditor
                                defaultValue={formik.values.description}
                                getResult={getDesc}
                            />
                            {
                                /* form message */
                                (formik.touched.description && formik.errors.description) && (
                                    <div className="st-form-msg position-absolute" style={{ bottom: -18 }}>
                                        <p className="st-fs-12">{formik.errors.description}</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}


export default memo(FormBasicDetails)